import befit from '../assets/images/certificates/befit.jpg';
import military from '../assets/images/certificates/military.jpg';
import ministry from '../assets/images/certificates/ministry.jpg';
import ofb from '../assets/images/certificates/ofb.jpg';
import perfectum from '../assets/images/certificates/perfectum.jpg';
import tower from '../assets/images/certificates/tower.jpg';

export const certificates = [ {
    thumbnail: befit
}, {
    thumbnail: military
}, {
    thumbnail: ministry
}, {
    thumbnail: ofb
}, {
    thumbnail: perfectum
}, {
    thumbnail: tower
} ];